module.exports = __webpack_public_path__ + "static/media/knowledge.8ee76093.png";